import React, { useEffect, useState } from "react";
import * as yup from "yup";
import AppForm from "../../../../partials/content/Forms/AppForm";
import {
  FormArrayTextField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";
import { FieldArray, useFormikContext } from "formik";
import { Table } from "react-bootstrap";
import Swal from "sweetalert2";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import Illustration from "../../../../partials/content/Illustration";
import { DialogActions } from "@material-ui/core";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchWarehouse from "../../inventory/warehouses/searchWarehouse";
import {
  getPlant,
  savePlant,
} from "../../../../services/production/productionService";
const plantSchema = yup.object().shape({
  ID: yup.number(),
  plantName: yup.string().required("Plant Name is required"),
});

function PlantForm({ plantID = 0, onConfirmSave, onCloseDialog }) {
  const [plant, setPlant] = useState({
    ID: 0,
    plantName: "",
    addressEmail: "",
    addressPhone: "",
    address: "",
    city: "",
    province: "",
    countryCode: "",
    postalCode: "",
    warehouses: [],
  });
  const getPlantData = async (plantID = 0) => {
    const response = await getPlant(plantID);
    const { data } = response.data;
    setPlant(data.plant);
  };
  useEffect(() => {
    if (plantID > 0) {
      getPlantData();
    }
  }, [plantID]);
  return (
    <AppForm
      initialValues={plant}
      validationSchema={plantSchema}
      onSubmit={(values, { resetForm, setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Plant ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              savePlant(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      <PlantFormContent onCloseDialog={onCloseDialog} />
    </AppForm>
  );
}

export default PlantForm;

function PlantFormContent({ onCloseDialog }) {
  const { values, setFieldValue, handleSubmit } = useFormikContext();
  const [itemIndex, setItemIndex] = useState(0);
  const [openSearchWarehouse, setOpenSearchWarehouse] = useState(0);
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6">
          <FormTextField label="Plant Name" name="plantName" />
          <FormTextField label="Phone Number" name="addressPhone" />
          <FormTextField label="Email" name="addressEmail" />
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6">
          <FormTextField
            label="Address"
            name="address"
            mapsButton
            onMapsClick={() => {
              //setOpenSearchMapPlaces(true);
            }}
          />
          <FormTextField label="City" name="city" />
          <FormTextField label="Province / State" name="province" />
          {/*
        <FormSelectField
                        label="Country"
                        name="countryCode"
                        options={countryOptions}
                      />
                            */}
          <FormTextField label="Postal Code" name="postalCode" />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <FieldArray name="warehouses">
            {({ push, remove }) => (
              <React.Fragment>
                <div className="row mb-3">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="card">
                      <Table borderless size="sm" responsive="xl">
                        {values.warehouses && values.warehouses.length > 0 ? (
                          <thead className="text-center">
                            <tr>
                              <th>Warehouse</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                        ) : null}
                        <tbody>
                          {values.warehouses && values.warehouses.length > 0 ? (
                            values.warehouses.map((item, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <tr>
                                    <td>
                                      <FormArrayTextField
                                        arrayPropName="warehouses"
                                        index={index}
                                        margin="none"
                                        propName="warehouseName"
                                        readonly
                                        searchButton
                                        onSearchClick={() => {
                                          setItemIndex(index);
                                          setOpenSearchWarehouse(true);
                                        }}
                                      />
                                    </td>
                                    <td
                                      style={{ whiteSpace: "nowrap" }}
                                      className="text-center"
                                    >
                                      <BootstrapTooltip
                                        title={
                                          item.deleteInd
                                            ? "Undo Delete"
                                            : "Delete A/P Invoice Item"
                                        }
                                      >
                                        <button
                                          type="button"
                                          className={`btn btn-icon btn-label-${
                                            item.deleteInd
                                              ? "warning"
                                              : "danger"
                                          } btn-md btn-circle mx-1`}
                                          onClick={() => {
                                            if (item.ID > 0) {
                                              setFieldValue(
                                                `warehouses[${index}].deleteInd`,
                                                !item.deleteInd
                                              );
                                            } else {
                                              setItemIndex(0);
                                              remove(index);
                                            }
                                          }}
                                        >
                                          {item.deleteInd ? (
                                            <i className="fas fa-undo-alt"></i>
                                          ) : (
                                            <i className="fas fa-trash-alt"></i>
                                          )}
                                        </button>
                                      </BootstrapTooltip>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            })
                          ) : (
                            <tr>
                              <td
                                className="text-center py-3"
                                colSpan={`${
                                  values.purchaseOrderID === 0 ? "8" : "7"
                                }`}
                              >
                                <Illustration
                                  imageSource="INVIFO Payment.png"
                                  guidance="Plant does not have warehouses"
                                  guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                  size="sm"
                                ></Illustration>
                              </td>
                            </tr>
                          )}
                          <tr>
                            <td className="text-center py-3" colSpan="8">
                              <button
                                type="button"
                                className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                                onClick={() => {
                                  push({
                                    ID: 0,
                                    plantID: 0,
                                    warehouseID: 0,
                                    warehouseName: "",
                                  });
                                }}
                              >
                                <i className="fas fa-plus-circle"></i>
                                Add Warehouse
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
                <DialogLayout
                  open={openSearchWarehouse}
                  title="Search Warehouse"
                  onCloseDialog={() => {}}
                  maxWIdth="md"
                >
                  <SearchWarehouse
                    onSelectWarehouse={(warehouse) => {
                      setFieldValue(
                        `warehouses[${itemIndex}].warehouseID`,
                        warehouse.ID
                      );
                      setFieldValue(
                        `warehouses[${itemIndex}].warehouseName`,
                        warehouse.warehouseName
                      );
                      setOpenSearchWarehouse(false);
                    }}
                  />
                  <DialogActions>
                    <button
                      type="button"
                      className="btn btn-label-danger btn-md btn-pill btn-bold"
                      onClick={() => {}}
                    >
                      <i className="fas fa-window-close"></i>
                      Close
                    </button>
                  </DialogActions>
                </DialogLayout>
              </React.Fragment>
            )}
          </FieldArray>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={() => {
                onCloseDialog();
              }}
            >
              <i className="fas fa-window-close"></i>
              Close
            </button>
            <button
              type="submit"
              className="btn btn-success btn-md btn-pill btn-bold"
            >
              <i className="fas fa-save"></i>
              Save
            </button>
          </DialogActions>
        </div>
      </div>
    </React.Fragment>
  );
}
